import * as z from 'zod';

import type {IInputItem} from 'src/components/scheduler/booking-v2/types/IInputItem';
import type {TranslationFunction} from 'src/types/language-support.ts';
import {validatePhone} from 'src/components/scheduler/booking-v2/utils/phone';
import type {CountryCode} from 'libphonenumber-js/max';


export const getFormSchema = ({
  items,
  countyCode,
  t,
}: {
  items: IInputItem[];
  countyCode: string;
  t: TranslationFunction;
}) => {
  const schemaObj = items.reduce((acc: {[k: string]: z.ZodTypeAny}, item) => {
    switch (item.type) {
      case 'text':
      case 'multi_line_text':
        acc[item.name] = z
          .string()
          .min(1, t('This_is_a_required_field', 'This is a required field'));
        break;
      case 'email':
        acc[item.name] = z
          .string()
          .min(1, t('This_is_a_required_field', 'This is a required field'))
          .email(
            t(
              'This_does_not_look_like_a_valid_email_address',
              'This does not look like a valid email address',
            ),
          );
        break;
      case 'phone':
        acc[item.name] = z
          .string()
          .min(1, t('This_is_a_required_field', 'This is a required field'))
          .refine((val) => validatePhone(val, countyCode as CountryCode), {
            message: t(
              'This_does_not_look_like_a_valid_phone_number',
              'This does not look like a valid phone number',
            ),
          });
        break;
      case 'consent':
        acc[item.name] = z
          .boolean()
          .refine(
            (val) => val === true,
            t('This_is_a_required_field', 'This is a required field'),
          );
        break;
      case 'checkbox':
        acc[item.name] = z.boolean();
        break;
      case 'number':
        acc[item.name] = z
          .string()
          .min(1, t('This_is_a_required_field', 'This is a required field'))
          .refine(
            (val) => !isNaN(Number(val)),
            t('Please_enter_a_valid_number', 'Please enter a valid number'),
          )
          .transform((val) => Number(val));
        break;
      case 'dropdown':
        acc[item.name] = z
          .string()
          .min(1, t('This_is_a_required_field', 'This is a required field'));
        break;
    }
    return acc;
  }, {});

  return z.object(schemaObj).required();
};
